import React from 'react';
import { Helmet } from 'react-helmet';

type HelmetWrapperProps = {
  title?: string;
  description?: string;
  facebookImg?: string;
  twitterImg?: string;
  url?: string;
};

const HelmetWrapper: React.FC<HelmetWrapperProps> = (props) => {
  const {
    children,
    url,
    title = 'Small to Medium Sized Businesses for Sale | Resolve',
    description = 'Resolve makes buying and selling businesses easy. Buy and sell privately, profitable or not, this is a place for businesses for sale. Investors sign up today!',
    facebookImg = 'https://media.resolve.com.au/public/assets/images/resolve-facebook.jpg?format=auto',
    twitterImg = 'https://media.resolve.com.au/public/assets/images/resolve-twitter.jpg?format=auto',
  } = props;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {url && <link rel="canonical" href={url} />}

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={facebookImg} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_GB" />
      {url && <meta property="og:url" content={url} />}

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={twitterImg} />
      <meta name="twitter:card" content="summary_large_image" />
      {url && <meta name="twitter:url" content={url} />}

      {children}
    </Helmet>
  );
};

export default HelmetWrapper;
